import { bbVars } from './configuration';
import { bBGET } from './http';
import { delay } from 'rxjs/operators';
import { bbCloseModal, bbUnloadIframe } from './interface';
var equal = require('deep-equal')

function initPayment() {
    if (bbVars.bbMpagoLibLoaded) {
        console.log('Lib loaded. Payment procces starting with data: ', bbVars.bbfConfig, JSON.stringify(bbVars.bbfConfig));
        loadCheckout(bbVars.bbfConfig)
        return;
    }
    console.log('Lib not loaded yet. Payment procces will not start');
}

var RequestConfig = () => {
    if (!!bbVars.bbOrderId) {
        bBGET('api/MercadoPago/Configuration/' + bbVars.bbOrderId)
            .pipe(delay(1000))
            .subscribe({
                next: (response) => {
                    if (response) {
                        console.log('RequestConfig: ', response);
                        loadCheckout(response);
                    }
                },
                error: (error) => {
                    document.getElementById('test-pay').disabled = false;
                    if (error.message) {
                        document.getElementById('test-error-label').innerHTML = error.message;
                    }
                }
            });
    }
}

function loadCheckout(preferenceID) {
    const mp = new MercadoPago(preferenceID.publicKey, {
        locale: preferenceID.locale
    });

    //mp.checkout({ preference: { id: preferenceID.paymentId }, autoOpen: true });
    // Initialize the checkout
    const bricksBuilder = mp.bricks();
    const renderComponent = async(bricksBuilder) => {
        console.log('renderComponent: ', bricksBuilder);
        if (window.checkoutButton) window.checkoutButton.unmount();
        await bricksBuilder.create(
            'wallet',
            'button-checkout', // class/id where the payment button will be displayed
            {
                initialization: {
                    preferenceId: preferenceID.paymentId,
                    redirectMode: "modal",
                },
                callbacks: {
                    onReady: () => {
                        console.log('onReady: ');
                        autoOpenModal();
                    },
                    onSubmit: () => console.log('onSubmit: ', ),
                    onError: (error) => console.error('onError: error ', error),
                }
            }
        );
    };
    window.checkoutButton = renderComponent(bricksBuilder);
}

function autoOpenModal() {
    var btns = document.getElementsByTagName("button");
    if (btns && btns.length) {
        btns[0].click();
    } else {
        setTimeout(() => autoOpenModal(), 1000);
    }
}

function onFirstMessageRecived(event) {
    onMessageReceived(event.data);
}

function onMessageReceived(event) {
    console.log('onMessageReceived: ', event);

    if (typeof event === 'string') {
        afterPaid(JSON.parse(event));
    }
    if (typeof event === 'object') {
        afterPaid(event);
    }
}

const afterPaid = (data) => {
    console.log('afterPaid: ', data, data.action, data.action === 'bbMPfinalize', data.action === 'bbMPclose');
    if (data && (data.action === 'bbMPfinalize' || data.action === 'bbMPclose')) {
        setTimeout(() => {
            bbCloseModal();
            CheckStatus();
        }, 500);
    }
    if (data && data.action === 'finalize') {
        setTimeout(() => {
            bbCloseModal();
            emitEvent(bbVars.bbOrderId, 'BBMPCANCELLED', data);
        }, 500);
    }
    if (data && data.action === 'submit') {
        NotifyToParentFromIframe(data);
    }
    if (data && data.action === 'bbMPapproved') {
        emitEvent(bbVars.bbOrderId, 'BBMPCOMPLETED', data);
    }
    if (data && data.action === 'bbMPpending') {
        emitEvent(bbVars.bbOrderId, 'BBMPPENDING', data);
    }
}

function NotifyToParentFromIframe(data) {
    if (data.data && data.data.type === 'submit' && data.data.value) {
        if (data.data.value.length) {
            var status = data.data.value.find(v => v.id === "payment_status");
            var action = 'finalize';
            if (status.value === 'approved') {
                action = 'bbMPapproved'
            }
            if (status.value === 'pending') {
                action = 'bbMPpending'
            }
            if (window.parent && window.parent.postMessage) {
                window.parent.postMessage({
                    action: action,
                    data: data.data
                }, '*');
            }
            return;
        }
    }
    if (window.parent && window.parent.postMessage) {
        let message = {
            action: 'bbMPfinalize',
            data: data.data
        };
        window.parent.postMessage(message, '*');
    }
}

const CheckStatus = () => {
    if (!bbVars.isFinalized) {
        bbVars.isFinalized = true;
        GetStatus();
    }
}

const actionAfterNotification = (data) => {
    console.log('notification$: ', data);
    if (data && data.notificationType == "success") {
        setTimeout(() => {
            bbCloseModal();
            CheckStatus();
        }, 500);
    }
}

const afterNavigatePayed = (data) => {
    console.log('afterNavigatePayed: ', data, bbVars.bbOrderId, data.orderId == bbVars.bbOrderId);
    if (data.orderId == bbVars.bbOrderId) {
        var action = 'none';
        switch (data.status) {
            case bbVars.bbStatusEnum.pending:
                if (bbVars.bbGetStatusCounter <= 2) {
                    GetStatus();
                    return;
                } else {
                    action = 'BBMPPENDIGN';
                }
                break;
            case bbVars.bbStatusEnum.completed:
                action = 'BBMPCOMPLETED';
                break;
            case bbVars.bbStatusEnum.incompleted:
                if (bbVars.bbGetStatusCounter <= 2) {
                    GetStatus();
                    return;
                } else {
                    action = 'BBMPINCOMPLETED';
                }
                break;
            case bbVars.bbStatusEnum.cancelled:
                action = 'BBMPCANCELLED';
                break;
            case bbVars.bbStatusEnum.unknown:
                action = 'BBMPUNKNOW';
                break;
            default:
                action = 'BBMPUNKNOW';
                break;
        }
        console.log('afterNavigatePayed action: ', action);
        if (action !== 'none') {
            emitEvent(bbVars.bbOrderId, action, data);
        } else {
            GetStatus();
        }
    }
}


const emitEvent = (orderId, action, data) => {
    bbVars.bbFunctionReturn({
        orderId: orderId,
        action: action,
        data: data
    });
    window.removeEventListener('message', onFirstMessageRecived);
    bbUnloadIframe();
    bbVars.bbGetStatusCounter = 0;
    console.log('emitEvent emmited');
    return;
}

const GetStatus = () => {
    bbVars.bbGetStatusCounter = bbVars.bbGetStatusCounter + 1;
    setTimeout(() => HTTPGetStatus(), 2500);
}

const HTTPGetStatus = () => {
    return bBGET(`api/MercadoPago/GetStatus/${bbVars.bbOrderId}`).subscribe({
        next: (data) => {
            if (data) {
                afterNavigatePayed(data);
            }
        },
        error: (error) => {
            console.log(error);
        }
    })
}

var iniyPayMessage = (event) => {
    let eventMessage = JSON.parse(JSON.stringify(event.data));
    console.log('initPay message with: ', eventMessage, typeof eventMessage);
    if (typeof eventMessage === 'object') {
        if (eventMessage.data) {
            const data = JSON.parse(JSON.stringify(eventMessage.data));
            console.log('initPay message: ', data, ' prevMessage: ', bbVars.prevMessage);
            console.log('compare: ', equal(data, bbVars.prevMessage));
            if (!equal(data, bbVars.prevMessage)) {
                bbVars.prevMessage = data;
                if (window.parent && window.parent.postMessage) {
                    window.parent.postMessage(data, '*');
                }
                if (window.opener && window.opener.postMessage) {
                    window.opener.postMessage(data, '*');
                }
            }
        } else {
            if (!eventMessage.action) {
                eventMessage = {
                    action: eventMessage.type ? eventMessage.type : 'unknow',
                    data: eventMessage
                }
            }
            if (!equal(eventMessage, bbVars.prevMessage)) {
                bbVars.prevMessage = eventMessage;
                if (window.parent && window.parent.postMessage) {
                    window.parent.postMessage(eventMessage, '*');
                }
                if (window.opener && window.opener.postMessage) {
                    window.opener.postMessage(eventMessage, '*');
                }
            }
        }
    } else {
        if (typeof eventMessage === 'string') {
            eventMessage = JSON.parse(eventMessage);
            console.log('initPay message with string object: ', eventMessage);
            if (eventMessage.data) {
                const data = JSON.parse(JSON.stringify(eventMessage));
                console.log('initPay message: ', data, ' prevMessage: ', bbVars.prevMessage);
                console.log('compare: ', equal(data, bbVars.prevMessage));
                if (!equal(data, bbVars.prevMessage)) {
                    bbVars.prevMessage = data;
                    if (window.parent && window.parent.postMessage) {
                        window.parent.postMessage(data, '*');
                    }
                    if (window.opener && window.opener.postMessage) {
                        window.opener.postMessage(data, '*');
                    }
                }
            }
        }
    }
}

export { initPayment, onMessageReceived, RequestConfig, actionAfterNotification, iniyPayMessage, onFirstMessageRecived }